export default __webpack_public_path__ + "static/media/button_deposit.fcb52e98.svg";